/**
 * Texts for Training page
 */
export const trainingPageText = {
    title: 'Addestramento - CamAPS FX',
    titleMeta: 'Forniamo corsi di addestramento online gratuiti per gli utilizzatori dell’app CamAPS FX',
    descriptionMeta: 'Il Cambridge Diabetes Education Programme è un programma educativo sul diabete che offre corsi di addestramento online certificati per persone con diabete di tipo 1, genitori e tutori, personale scolastico e operatori sanitari.',
    keywords: 'camaps addestramento, camaps fx addestramento,  ',
    localeMeta: 'it',
    mainHeader: 'Formazione sanitari',
    mainSubHeader: 'Supporti le persone che utilizzano CamAPS FX con una formazione guidata da esperti.',
    gettingStartedHeader: 'Primi passi',
    step1Title: '<strong>Passo 1:</strong><br/>Scaricate l\'app',
    step2Title: '<strong>Passo 2:</strong><br/>Create un account',
    step3Title: '<strong>Passo 3:</strong><br/>Iniziate la formazione essenziale in-app',
    step4Title: '<strong>Passo 4:</strong><br/>Accoppiate con la vostra pompa e CGM scelti (con l\'approvazione del vostro team sanitario) o esplorate l\'app con la <strong>modalità virtuale</strong>',
    videoSrc: '/video/In-app training loop_1.mp4',
    certifiedTrainingTitle: 'Addestramento certificato',
    trainingHeader: 'Addestramento certificato',
    trainingHeader_2: 'Per operatori sanitari',
    trainingHeader_3: 'Formazione degli utenti',
    trainingHeaderText: 'Corso di addestramento online GRATUITO all’app CamAPS FX offerto dal Cambridge Diabetes Education Programme (CDEP).',
    websiteLink: 'https://www.camdiabtraining.com/account-sign-in.html',
    websiteLinkHeading: 'Addestramento CDEP',
    getTrained: 'Partecipa all’addestramento',
    trainingHeaderIat: 'Formazione CamAPS FX',
    trainingHeaderTextIat: 'Completa il training essenziale in-app prima di utilizzare l\'app CamAPS FX.',
    trainingSubHeaderOneIat: 'Iniziare',
    trainingSubTextOneIat: 'Scarica l\'app CamAPS FX. <br>Crea un account per iniziare il training.',
    trainingSubHeaderTwoIat: 'Hai bisogno di aiuto per installare l\'app?',
    trainingParaTwoStartIat: 'Visita la nostra',
    trainingParaTwoEndIat: 'sezione per indicazioni.',
    websiteLinkHeadingSupportIat: 'Supporto',
    trainingSubHeaderThreeIat: 'Risorse aggiuntive',
    animationsYpsoPumpText: 'Animazioni',
    animationsAndText: 'e',
    animationsDanaText: 'Animazioni (pompa Dana)',
    animationsFurtherText: 'Impara attraverso visuali passo dopo passo.',
    webinarsText: 'Webinar',
    webinarsFurtherText: 'Guarda sessioni condotte da esperti sull\'uso dell\'app.',
    websiteAnimationsYpsoPumpLink: 'https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm',
    websiteAnimationsDanaLink: 'https://www.camdiabtraining.com/view/25/Dana-insulin-pump-users.htm',
    websiteWebinarsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
};
